import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import {
  getPeriodsAsQueryParameters,
  getMarinePeriodsAsQueryParameters
} from "../../../utils/general";
import LinkTimeSeries from "../LinkTimeSeries/LinkTimeSeries";
import "./Popup.css";
import { addClassToPopup, removeClassToPopup } from "./popupUtils";
import {
  fetchSynopTimelinessPopupInfo,
  fetchSynopCombinedOrAvailabilityPopup,
  fetchSynopSimplePopup,
  fetchSynopAlertCombinedPopup,
  fetchSynopAlertSimplePopup
} from "./SynopPopup";
import {
  fetchTempSixHourAvailabilityPopup,
  fetchTempDailyOrMonthlySimplePopup,
  fetchTempDailyOrMonthlyCombinedPopup,
  fetchTempQualityPopup
} from "./TempPopup";
import { fetchWis2gtssynopPopupInfo } from "./Wis2gtsSynopPopup";
import { fetchWis2gtstempPopupInfo } from "./Wis2gtsTempPopup";
import { fetchShipPopupInfo } from "./ShipPopup";
import { fetchBuoyPopupInfo } from "./BuoyPopup";

export { addClassToPopup, removeClassToPopup };

const Popup = props => {
  const [content, setContent] = useState(<Spin tip="Loading..." />);

  const center = props.combinedMode ? "all" : props.selectedCenter;
  let dateUntil;
  if (props.selectedPeriodType === "six_hour") {
    dateUntil = props.selectedDate + " " + props.selectedSixHPeriod + ":00:00";
  } else if (
    props.selectedPeriodType === "daily" ||
    props.selectedPeriodType === "alert"
  ) {
    dateUntil = props.selectedDate + " 00:00:00";
  } else if (props.selectedPeriodType === "monthly") {
    dateUntil = props.selectedDate + "-01 00:00:00";
  } else if (props.selectedPeriodType === "hourly") {
    dateUntil =
      props.selectedDate + " " + props.selectedHourlyPeriod + ":00:00";
  }

  const dataParams = {
    station: props.stationObject.station_id,
    date: dateUntil,
    center
  };

  let TSTypes = "single";
  if (
    props.fileType === "temp" &&
    props.selectedReport === "quality" &&
    props.combinedMode
  ) {
    TSTypes = [
      { id: "Stra", name: "Stra" },
      { id: "Trop", name: "Trop" }
    ];
  } else if (
    ["synop", "ship", "buoy", "marine_surface"].includes(props.fileType) &&
    props.selectedReport === "quality" &&
    props.selectedPeriodType === "monthly" &&
    props.combinedMode
  ) {
    TSTypes = [
      { id: "rms", name: "RMSE" },
      { id: "gross_error_percent", name: "GE %" }
    ];
  }

  const linkTimeSeries = (
    <LinkTimeSeries
      type={TSTypes}
      fileType={props.fileType}
      data={dataParams}
      onSetChartData={props.onSetChartData}
      setVisible={props.setVisible}
      selectedReport={props.selectedReport}
      combinedMode={props.combinedMode}
      selectedVariable={props.selectedVariable}
      selectedPeriodType={props.selectedPeriodType}
      onSetLevel={props.onSetLevel}
      baseline={props.baseline}
      stationObject={props.stationObject}
    />
  );

  let expectedGBON;
  if (props.baseline === "GBON") {
    let valueGBON;
    if (props.fileType === "synop") {
      if (props.selectedPeriodType === "six_hour") {
        valueGBON = 6;
      } else if (props.selectedPeriodType === "daily") {
        valueGBON = 24;
      } else if (props.selectedPeriodType === "monthly") {
        valueGBON = props.stationObject.nr_expected;
      }
    } else if (props.fileType === "temp") {
      if (props.selectedPeriodType === "six_hour") {
        valueGBON = 0;
      } else if (props.selectedPeriodType === "daily") {
        valueGBON = 2;
      } else if (props.selectedPeriodType === "monthly") {
        valueGBON = props.stationObject.nr_expected;
      }
    }
    if (valueGBON) {
      expectedGBON = { name: "#Expected", value: valueGBON };
    }
  }

  let multiplier = 1;
  if (props.selectedVariable === "58" || props.selectedVariable === "29") {
    multiplier = 100;
  }

  const report = props.selectedReport;

  useEffect(() => {
    if (props.fileType === "synop") {
      removeClassToPopup();
      if (props.selectedReport === "timeliness") {
        fetchSynopTimelinessPopupInfo(
          props,
          report,
          periodsAsQP,
          multiplier,
          linkTimeSeries,
          setContent
        );
      } else if (
        (props.combinedMode || props.selectedReport === "availability") &&
        props.selectedPeriodType !== "alert"
      ) {
        fetchSynopCombinedOrAvailabilityPopup(
          props,
          report,
          periodsAsQP,
          multiplier,
          linkTimeSeries,
          setContent,
          expectedGBON
        );
      } else if (props.selectedPeriodType !== "alert") {
        fetchSynopSimplePopup(
          props,
          periodsAsQP,
          multiplier,
          linkTimeSeries,
          setContent
        );
      } else {
        if (props.combinedMode) {
          fetchSynopAlertCombinedPopup(
            props,
            report,
            dateUntil,
            center,
            multiplier,
            linkTimeSeries,
            setContent
          );
        } else {
          fetchSynopAlertSimplePopup(
            props,
            multiplier,
            linkTimeSeries,
            setContent
          );
        }
      }
    } else if (props.fileType === "marine_surface") {
      removeClassToPopup();
      if (props.stationObject.file_type === "buoy") {
        fetchBuoyPopupInfo(
          props,
          periodsAsQP,
          linkTimeSeries,
          setContent,
          multiplier
        );
      } else {
        fetchShipPopupInfo(
          props,
          periodsAsQP,
          linkTimeSeries,
          setContent,
          multiplier
        );
      }
    } else if (props.fileType === "temp") {
      removeClassToPopup();
      if (props.selectedReport === "availability") {
        if (props.selectedPeriodType === "six_hour") {
          fetchTempSixHourAvailabilityPopup(
            props,
            periodsAsQP,
            linkTimeSeries,
            setContent,
            addClassToPopup
          );
        } else if (
          (props.selectedPeriodType === "daily" ||
            props.selectedPeriodType === "monthly") &&
          !props.combinedMode
        ) {
          fetchTempDailyOrMonthlySimplePopup(
            props,
            linkTimeSeries,
            setContent,
            expectedGBON
          );
        } else if (
          (props.selectedPeriodType === "daily" ||
            props.selectedPeriodType === "monthly") &&
          props.combinedMode
        ) {
          fetchTempDailyOrMonthlyCombinedPopup(
            props,
            periodsAsQP,
            linkTimeSeries,
            setContent,
            expectedGBON
          );
        }
      } else {
        fetchTempQualityPopup(
          props,
          periodsAsQP,
          multiplier,
          linkTimeSeries,
          setContent
        );
      }
    } else if (props.fileType === "wis2gtssynop") {
      removeClassToPopup();
      fetchWis2gtssynopPopupInfo(
        props,
        periodsAsQP,
        linkTimeSeries,
        setContent
      );
    } else if (props.fileType === "wis2gtstemp") {
      removeClassToPopup();
      fetchWis2gtstempPopupInfo(props, periodsAsQP, linkTimeSeries, setContent);
    }
  }, [props.baseline]);

  let periodsAsQP;

  if (props.fileType == "wis2gtssynop" || props.fileType == "wis2gtstemp") {
    if (props.selectedReport === "wis2live") {
      periodsAsQP = getPeriodsAsQueryParameters(
        props.periodData,
        props.selectedPeriodType,
        props.selectedCenter,
        props.selectedDate,
        props.selectedHourlyPeriod
      );
    } else if (
      props.selectedReport === "gts-to-wis2" ||
      props.selectedReport === "tac-to-bufr" ||
      props.selectedReport === "bufr_oscar_coords"
    ) {
      periodsAsQP = getPeriodsAsQueryParameters(
        props.periodData,
        props.selectedPeriodType,
        props.selectedCenter,
        props.selectedDate,
        props.selectedSixHPeriod
      );
    }
  } else if (props.fileType === "marine_surface") {
    const marineFileType = props.stationObject.file_type
      ? props.stationObject.file_type.toUpperCase()
      : "BUOY";
    periodsAsQP = getMarinePeriodsAsQueryParameters(
      marineFileType,
      props.periodData,
      props.selectedPeriodType,
      props.selectedCenter,
      props.selectedDate,
      props.selectedSixHPeriod
    );
  } else if (props.fileType !== "marine_surface") {
    // Check if snow depth is selected and use SDEP periods instead
    if (props.selectedVariable === "71") {
      console.log("Snow depth selected in popup, checking SDEP periods");

      // Check if SDEP periods are loaded
      if (props.sdepPeriods && props.sdepPeriods.dates) {
        // Select the correct date structure based on period type
        const sdepDates =
          props.selectedPeriodType === "daily"
            ? props.sdepPeriods.dailyDates
            : props.selectedPeriodType === "monthly"
            ? props.sdepPeriods.monthlyDates
            : props.sdepPeriods.dates;

        // Guard: ensure the selected date exists in SDEP data for the selected center
        const sdepDateAvailable =
          sdepDates &&
          sdepDates[props.selectedCenter] &&
          sdepDates[props.selectedCenter][props.selectedDate] !== undefined;

        if (sdepDateAvailable) {
          const sdepPeriodData = {
            [props.selectedPeriodType]: { dates: sdepDates }
          };

          periodsAsQP = getPeriodsAsQueryParameters(
            sdepPeriodData,
            props.selectedPeriodType,
            props.selectedCenter,
            props.selectedDate,
            props.selectedSixHPeriod
          );

          console.log("Using SDEP periods in popup:", periodsAsQP);
        } else {
          periodsAsQP = getPeriodsAsQueryParameters(
            props.periodData,
            props.selectedPeriodType,
            props.selectedCenter,
            props.selectedDate,
            props.selectedSixHPeriod
          );
        }
      } else {
        // Fallback to regular periods if SDEP periods not loaded yet
        console.warn(
          "SDEP periods not loaded yet in popup, using regular periods"
        );
        periodsAsQP = getPeriodsAsQueryParameters(
          props.periodData,
          props.selectedPeriodType,
          props.selectedCenter,
          props.selectedDate,
          props.selectedSixHPeriod
        );
      }
    } else {
      // Use regular periods for non-snow depth variables
      periodsAsQP = getPeriodsAsQueryParameters(
        props.periodData,
        props.selectedPeriodType,
        props.selectedCenter,
        props.selectedDate,
        props.selectedSixHPeriod
      );
    }
  }
  return (
    <>
      <button
        onClick={props.obj.remove}
        className="mapboxgl-popup-close-button"
        type="button"
        aria-label="Close popup"
      >
        ×
      </button>
      <div id="popup-content">{content}</div>
    </>
  );
};

export default Popup;
